"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTestimonials = void 0;
var Api_1 = require("@/api/remote/Api");
exports.getTestimonials = function (languageCode, pageNumber, agentId, sortBy, orderBy) {
    var path = [
        languageCode,
        'api',
        'general',
        'GetAgentTestimonials',
    ].join('/');
    return Api_1.api().post(path, {
        pageNumber: pageNumber,
        agentId: agentId,
        sortBy: sortBy,
        orderBy: orderBy,
    });
};
